/**
 * 打卡活动接口
 */

import { apiProxy } from '../util-lib/http';
import { ensureParams } from '../util-lib/api-proxy';

// 获取活动配置
export async function getInfo(params = {}) {
  params = ensureParams(params, getInfo.__definedParams);
  const api = 'api/v1.0/Poi/Activity/GetPunchCardInfo';
  const body = await apiProxy.get(api, { params });
  return body.getPunchCardInfo.data;
}

getInfo.__definedParams = {
  activityToken: ''
};

// 设置活动状态
export async function setInfo(params = {}) {
  params = ensureParams(params, setInfo.__definedParams);
  const api = 'api/v1.0/Poi/Activity/SetPunchCardInfo';
  const body = await apiProxy.get(api, { params });
  return body.setPunchCardInfo.data;
}

setInfo.__definedParams = {
  activityToken: '',
  action: '',
  phone: '',
  dailyOffset: ''
};
